/**
 * O vocabulário do "Recalcular CENA" (2026-11-04): as partes que a pessoa
 * escolhe recalcular, os desfechos por menção e as notas que explicam por
 * que uma menção não pôde ser recalculada por inteiro.
 *
 * Espelho de `CENA_RECALC_PARTS` do `core/vocabulary.py`. A tupla é
 * `as const` e os rótulos são tipados sobre ela DE PROPÓSITO: parte a
 * menos ou a mais é erro de compilação, não uma chave crua na tela.
 */

export const CENA_RECALC_PARTS = [
  "vehicle_tier",
  "format",
  "channel_weight",
  "publisher",
  "weights"
] as const;
export type CenaRecalcPart = (typeof CENA_RECALC_PARTS)[number];

export const CENA_RECALC_PART_LABELS: Record<CenaRecalcPart, string> = {
  vehicle_tier: "Tier do veículo",
  format: "Formato P/M/G",
  channel_weight: "Peso do canal",
  publisher: "Porte e grupo do publicador",
  weights: "Pesos da classificação"
};

export const CENA_RECALC_PART_HINTS: Record<CenaRecalcPart, string> = {
  vehicle_tier: "Relê o tier do veículo no cadastro e o ponto dele no CENA.",
  format: "Relê o tipo do veículo e o texto (ou a duração) pra refazer o formato.",
  channel_weight: "Relê o peso do canal no cadastro.",
  publisher: "Relê a faixa de porte e o grupo do publicador.",
  weights:
    "Sentimento, abordagem, mensagem-chave, porta-voz e citação no título com os pesos do CENA de hoje."
};

/** Os grupos da caixa de escolha, na ordem em que aparecem. */
export const CENA_RECALC_PART_GROUPS: { title: string; parts: readonly CenaRecalcPart[] }[] = [
  { title: "Imprensa", parts: ["vehicle_tier", "format"] },
  { title: "Redes", parts: ["channel_weight", "publisher"] },
  { title: "As duas", parts: ["weights"] }
];

export const CENA_RECALC_STATUSES = ["QUEUED", "STARTED", "FINISHED", "ERRORED"] as const;
export type CenaRecalcStatus = (typeof CENA_RECALC_STATUSES)[number];

export const CENA_RECALC_OUTCOMES = ["changed", "unchanged", "failed", "conflict"] as const;
export type CenaRecalcOutcome = (typeof CENA_RECALC_OUTCOMES)[number];

export const CENA_RECALC_OUTCOME_LABELS: Record<CenaRecalcOutcome, string> = {
  changed: "Mudou de nota",
  unchanged: "Ficou igual",
  failed: "Falhou",
  conflict: "Alterada durante o recálculo"
};

export const CENA_RECALC_NOTES = [
  "vehicle_not_found",
  "channel_not_found",
  "no_format_data"
] as const;
export type CenaRecalcNote = (typeof CENA_RECALC_NOTES)[number];

export const CENA_RECALC_NOTE_LABELS: Record<CenaRecalcNote, string> = {
  vehicle_not_found: "veículo não está no cadastro",
  channel_not_found: "canal não está no cadastro",
  no_format_data: "sem duração/texto pra calcular o formato"
};
